import { useSelector } from 'react-redux';
import { useId, useEffect } from 'react';
import circle from '@turf/circle';
import { useTheme } from '@mui/styles';
import { map } from '../core/MapView';

const MapAccuracy = ({ positions, displayForAllPositions = false }) => {
  const id = useId();
  const selectedDeviceId = useSelector((state) => state.devices.selectedId);

  const theme = useTheme();

  useEffect(() => {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [],
      },
    });
    map.addLayer({
      source: id,
      id,
      type: 'fill',
      filter: [
        'all',
        ['==', '$type', 'Polygon'],
      ],
      paint: {
        'fill-color': theme.palette.colors.geometry,
        'fill-outline-color': theme.palette.colors.geometry,
        'fill-opacity': 0.25,
      },
    });

    return () => {
      if (map.getLayer(id)) {
        map.removeLayer(id);
      }
      if (map.getSource(id)) {
        map.removeSource(id);
      }
    };
  }, []);

  useEffect(() => {
    map.getSource(id)?.setData({
      type: 'FeatureCollection',
      features: positions
        .filter((position) => position.accuracy > 0 && (displayForAllPositions ? true : position.deviceId === selectedDeviceId))
        .map((position) => circle([position.longitude, position.latitude], position.accuracy * 0.001)),
    });
  }, [positions, selectedDeviceId, displayForAllPositions]);

  return null;
};

export default MapAccuracy;
